import { z } from 'zod';

import { CompanyInterestOnEscrowSettingId } from '../BrandedIds';
import { zodBrandedString } from '../utils';
import { StateAbbreviation } from '../validations/fields';

export const CompanyInterestOnEscrowSetting = z.object({
  id: zodBrandedString<CompanyInterestOnEscrowSettingId>(), // Static string to enable Apollo caching
  stateAbbreviation: StateAbbreviation, // 2-letter state abbreviation
  year: z.number(),
  month: z.number(),
  interestRate: z.number().nullable(), // 5 decimal places of percentage precision; nullable if rate not yet known or user cleared it
});
export type CompanyInterestOnEscrowSetting = z.infer<typeof CompanyInterestOnEscrowSetting>;
